export const capitalizeFirstLetter = (value = "") => {
  if (typeof value !== "string") return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
};
export const handleOverviewKeyDown = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Tab",
    "Enter",
    "Delete",
    " "
  ];

  if (allowedKeys.includes(e.key)) return;


  const regex = /^[a-zA-Z]$/;

  if (!regex.test(e.key)) {
    e.preventDefault();
  }
};
export const handleNumberKeyDown = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
  ];

  // Allow control keys
  if (allowedKeys.includes(e.key)) return;

  // Allow only digits
  if (!/^[0-9]$/.test(e.key)) {
    e.preventDefault();
  }
};
export const maskedEmail = (email) => {
  return email ? email.slice(0, 5) + "******" + email.slice(-6) : "";
};


